// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import EyeCloseSvg from '@rsuite/icon-font/lib/status/EyeClose';
var EyeClose = createSvgIcon({
  as: EyeCloseSvg,
  ariaLabel: 'eye close',
  category: 'status',
  displayName: 'EyeClose'
});
export default EyeClose;